<template>
<div class="chapter">
<div class="inner_page">
<div id="Quote.html" xml:lang="en-US">
<div class="Basic-Text-Frame-15">
<p class="epigraph"><a id="Anchor-1">“People will stare. Make it worth their while.”</a></p><a id="Anchor-1">
<p class="citation">—Harry Winston</p>
<p class="Basic-Paragraph-12">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Quote.vue?7513d95f